import { createContext, useContext } from "react";

import type { MenuProps } from "./Menu.types";

type MenuContextValue = Pick<
  MenuProps,
  "size" | "variant" | "align" | "side" | "arrow"
>;

export function makeMenuContext({
  size = "md",
  variant = "default",
  align = "start",
  side = "bottom",
  arrow = false,
}: MenuContextValue): Required<MenuContextValue> {
  return { size, variant, align, side, arrow };
}

export const MenuContext = createContext<Required<MenuContextValue>>(
  makeMenuContext({}),
);

export function useMenuContext() {
  return useContext(MenuContext);
}
